var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.061 4.03a.7.7 0 0 0-.19.126c-.053.049-2.915 3.455-6.36 7.568l-6.262 7.48-2.552-2.665c-1.404-1.465-2.594-2.691-2.645-2.724a.8.8 0 0 0-.234-.087c-.551-.106-.984.476-.756 1.018.04.095.527.615 2.917 3.113 3.207 3.353 2.98 3.138 3.303 3.138.147 0 .191-.01.309-.072.133-.07.348-.322 6.71-7.921 3.787-4.522 6.6-7.9 6.636-7.97.056-.106.064-.144.063-.318 0-.227-.044-.348-.178-.495a.58.58 0 0 0-.476-.22.8.8 0 0 0-.285.03",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmark;